import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    buttonRoot: {
        whiteSpace: 'nowrap',
        '@media (max-width: 480px)': {
            display: 'none'
        }
    },
    icon: {
        width: 12,
        height: 12,
        padding: 2,
        background: 'linear-gradient(249.05deg, #FF8B61 7.18%, #D92E7F 172.88%)',
        color: '#fff',
        marginRight: 8,
        borderRadius: '50%'
    }
});
